export default __webpack_public_path__ + "flagGB.0f6cd6508cfedfcaa1a1eed402b2793e.png";